<template>
	<div class="faq">
		<div class="faqWarp">
			<div class="left">
				<ul class="prependNav">
					<li v-for="(item, index) in deviceData" :class="{ 'active': index == currentIndex ? true : false }" @click="getBarData(item.seriesName,index)">
						{{item.seriesName}}
					</li>
				</ul>
			</div>
		
			<div class="right" :scrollTop.prop="scrollTop" id="goodsList" ref="goodsList">
				<div class="panel" v-for="(item, index) in deviceData"  :id="item.seriesName">
					<div class="title">{{item.seriesName}}</div>
					<ul>
						<li class="" v-for="(val, key) in item.device" @click="toNextPage(val.child,val.deviceId)">
							<div class="equipmentCon">
								<div class="icon"><img :src="val.imgPath"/></div>
								<p>{{val.deviceName}}</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<menuChild ref="menuChild"></menuChild>
			<el-dialog :visible="showPopup" class="dialog" :close-on-click-modal="true" :show-close="false" @close="showPopup = false"> 
			  	<div class="equi-wrapper">
			       <div class="title">选择要查看的类型</div>
			       <div class="content">
			       		<ul :style="{ textAlign: textAlign }">
			       			<li v-for="(item, index) in currentChildData" @click="toTypeList(item.deviceId)">
			       				<div class="icon">
			       					<img :src="item.imgPath"/>
			       				</div>
			       				<p>{{item.deviceName}}</p>
			       			</li>
			       		</ul>
			       		<div class="closeBtn" @click="close">
			       			<img :src="images.close"/>
			       		</div>
			       </div>
			    </div>
			</el-dialog>
			<ercode></ercode>
			
		</div>
		
	</div>
</template>

<script>
	import { get, isPC } from 'assets/api/config'
	import ercode from 'components/ercode'
	import menuChild from 'components/menuList'
	
	var img = {};
	img.close = require('../../assets/images/faq_del.png');
	
	export default {
		data() {
			return {
				images: img,
				deviceData:'',
				tabBar:'',
				currentTag:'',//当前导航
		      	currentIndex:0,//当前索引
		      	currentChildData:'',//当前子元素数据
		      	showPopup:false,
		      	textAlign:"left",//弹窗排版
		      	scrollTop:0,
		      	offsetTopArr:[],//存储右边菜单板块高度
		      	leftIndex:0,
		      	isScroll:true,
			}
		},
		mounted: function() {
			let that = this;
			this.init();
			this.$nextTick(() => {
				let domScroll = document.querySelector("#goodsList");
				let itemChild = '';
				let offsetTopArr = [];
				
				let time = setInterval(function(){
					if(document.querySelectorAll(".panel")){
						itemChild = document.querySelectorAll(".panel");
						for(let i =0;i<itemChild.length;i++){
							offsetTopArr.push({'top':itemChild[i].offsetTop,'index':i})
						}
						
						that.offsetTopArr = offsetTopArr; 
//						console.log("offsetTopArr",offsetTopArr)
						clearInterval(time)
					}
				},100)
				
//				domScroll.addEventListener('scroll', this._initScroll)
			})
			
		},
		methods: {
			init(){
				let that = this;
				//游戏详情
				let data = {
					token: '',
					act: 'webInstruction',
				}
				
				get(data).then(function(res) {
					that.deviceData = res.data.device;
	 				that.tabBar = res.data.series;
	 				that.currentTag = res.data.device[0].seriesName;
//					console.log(res)
				});
			},
			getBarData(current,index){
		    	//获取当前导航标签和索引
		    	this.currentTag = current;
		    	this.currentIndex = index;
		    	
		    	//获取滚动高度
		    	let offsetTop = document.querySelector("#"+current).offsetTop;
//		    	document.querySelector("#"+current).scrollIntoView(true);
//		    	this.scrollAnimate(offsetTop-18);
				this.scrollAnimate(offsetTop);
		    },
		    scrollAnimate(offsetTop){
		    	let that = this;
		    	this.isScroll = false;
		    	
		    	this.$nextTick(() => {
		    		//获取
		    		let domScrollTop = document.querySelector("#goodsList").scrollTop;
		    		console.log('当前的domScrollTop：',domScrollTop)
		    		console.log("传入的offsetTop：",offsetTop)
		    		
		    		if(offsetTop > domScrollTop){
		    			//向下滚动
		    			let step = (offsetTop - domScrollTop)/50;
		    			console.log(step)
		    			smoothDown(step);
		    		}
		    		
		    		if(offsetTop < domScrollTop){
		    			//向上滚动
		    			let step = (domScrollTop - offsetTop)/50;
		    			smoothUp(step);
		    		}
		    		
		    		setTimeout(function(){
		    			that.isScroll = true;
		    		},1000)
		    		
		    		function smoothDown(step){
		    			//向下滚动
		    			if(offsetTop > domScrollTop){
		    				domScrollTop = parseFloat(domScrollTop) + parseFloat(step);
		    				that.scrollTop = domScrollTop;
		    				
		    				setTimeout(function(){
		    					smoothDown(step)
		    				},5)
		    			}else{
		    				console.log(offsetTop)
		    				that.scrollTop = offsetTop;
		    			}
		    		}
		    		
		    		function smoothUp (step) {
	                  //向上滚动
	                  	if(offsetTop < domScrollTop){
		    				domScrollTop = parseFloat(domScrollTop) - parseFloat(step);
		    				that.scrollTop = domScrollTop;
		    				
		    				setTimeout(function(){
		    					smoothUp(step)
		    				},5)
		    			}else{
		    				console.log(offsetTop)
		    				that.scrollTop = offsetTop;
		    			}
	                } 
//					this.scrollTop = offsetTop
					
			    });
		    },
		    toNextPage(obj,id){
		    	//判断是否有二级界面子元素
		    	if(typeof obj != 'undefined'){
		    		this.currentChildData = obj;
		    		this.showPopup = true;
		    		if(obj.length < 2){
		    			this.textAlign = 'center'
		    		}else{
		    			this.textAlign = 'left'
		    		}
//		    		console.log(obj)
		    	}else{
		    		this.toTypeList(id)
		    	}
		    	
		    },
		    toTypeList(id){
		    	this.showPopup = false;
		    	this.$router.push({name:'device',params:{id:id,keyId:'0'}})
		    },
		    _initScroll(){
		    	if(this.isScroll){
		    		let that = this;
			    	let scrollTop = document.querySelector("#goodsList").scrollTop;
			    	console.log('当前top',document.querySelector("#goodsList").scrollTop);
			    	console.log("当前被选中",this.currentIndex)
					for(let i=0;i<this.offsetTopArr.length;i++){
						if(i < this.offsetTopArr.length - 1){
							if(scrollTop > this.offsetTopArr[i].top && scrollTop < this.offsetTopArr[i+1].top){
								this.currentIndex = i;
								this.scrollTop = this.offsetTopArr[i].top;
								console.log('第'+i+'个')
								break;
							}
	//						console.log('i:',this.offsetTopArr[i].top);
	//						console.log('i+1',this.offsetTopArr[i+1].top)
						}else{
	//						console.log('最后一个i:',this.offsetTopArr[i].top);
						}
					}
		    	}
		    	
		    },
		    close(){
//		    	this.$refs.savePopup.hide();
		    	this.showPopup = false;
		    },
		},
		components: {
		    ercode,
		    menuChild
	 	},
		watch: {
		},

	}
</script>

<style lang="less" scoped>
	.faq{
		background-color: #f7f7f7;
		
		.dialog{
			background-color: rgba(0,0,0,0.8);
		}
		
		.faqWarp{
			position: relative;
			margin: 0 auto;
			height: 100vh;
			max-width: 610PX;
			background-color: #fff;
			
			.posiWarp{
				width: 100%;
				height: 100%;
			}
			
			.left{
				display: inline-block;
				width: 112PX;
				height: 100vh;
				background-color: #f2f2f2;
				overflow-y: scroll;
				
				.prependNav{
					li{
						height: 80PX;
						line-height: 80PX;
						color: #999;
						font-size: 20PX;
						text-align: center;
						cursor: pointer;
					}
					
					li.active{
						background-color: #fff;
						color: #cd3c3d;
					}
				}
			}
			
			.right{
				/*padding-bottom: 20PX;*/
				display: inline-block;
				width: 490PX;
				height: 100vh;
				background-color: #fff;
				overflow-y: scroll;
				
				.panel{
					.title{
						margin: 28PX 0;
						color: #000;
						font-size: 20PX;
						text-align: center;
					}
					
					ul{
						li{
							display: inline-flex;
							justify-content: center;
							align-items: center;
							width: 238PX;
							height: 160PX;
							cursor: pointer;
							
							.equipmentCon{
								.icon{
									margin: 0 auto;
									width: 80%;
									
									img{
										width: 100%;
									}
								}
								
								p{
									margin-top: 12PX;
									text-align: center;
									font-size: 18PX;
									color: #333;
								}
							}
							
							
						}
						
						li:hover{
							background-color: #f2f2f2;
						}
					}
				}
			}
			
			
			.equi-wrapper{
				.title{
					color: #fff;
					font-size: 20PX;
					font-weight: bold;
					text-align: center;
				}
				
				.content{
					margin-top: 50PX;
					text-align: left;
					
					ul{
						width: 498PX;
						margin: 0 auto;
						
						li{
							display: inline-block;
							padding: 30PX 0;
							margin-right: 30PX;
							margin-bottom: 30PX;
							width: 142PX;
							/*height: 174PX;*/
							border: 2PX solid #fff;
							border-radius: 30PX;
							text-align: center;
							cursor: pointer;
							
							.icon{
								display: block;
								margin: 0 auto;
								height:80PX;
								width:80PX;
								/*height: 150PX;*/
								
								img{
									width: 100%;
								}
							}
							
							p{
								margin-top: 16PX;
								color: #fff;
								font-size: 20PX;
							}
						}
						
						li:nth-child(3n){
							margin-right: 0;
						}
						
						li:last-child{
							margin-right: 0;
						}
					}
					
					.closeBtn{
						position: fixed;
						top: 90vh;
						left: 0;
						width: 100%;
						text-align: center;
						
						img{
							width: 40PX;
						}
					}
				}
			}
			
		}
	}
		
</style>


// WEBPACK FOOTER //
// src/page/faqPC/index.vue